/**
 * 路由默认存放
 * 不配置站点地图路由
 */

//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    //* 过渡页面路由
    {
        name: "Transition",
        path: "/transition",
        component: () => import("@/views/public/functions/Transition.vue"),
    },

    //* 个人中心路由
    {
        name: "UserLayout",
        path: "/user",
        meta: { permission: true },
        component: () => import("@/views/user/components/layout/index.vue"),
        children: [
            {
                name: "UserInfo",
                path: "",
                component: () => import("@/views/user/views/info/index.vue"),
            },
            {
                name: "UserAgent",
                path: "agent",
                component: () => import("@/views/user/views/agent/index.vue"),
            },
            {
                name: "UserFeedback",
                path: "feedback",
                component: () => import("@/views/user/views/feedback/index.vue"),
            },
            {
                name: "UserFavorites",
                path: "favorites",
                component: () => import("@/views/user/views/favorites/index.vue"),
            },
            {
                name: "UserRecentActivity",
                path: "history",
                component: () => import("@/views/user/views/history/index.vue"),
            },
        ],
    },
] as RouteRecordRaw[];
